<template>
    <div>
        <div v-auto-animate>
            <div
                class="flex items-center justify-between rounded-md border border-iron-200 px-4 py-2"
            >
                <div>
                    <p class="font-semibold text-iron-600">
                        {{ title }}
                    </p>

                    <p class="text-sm">
                        {{ assignedWorkflows?.length }}
                        {{
                            $t(
                                "workflows.steps.active",
                                assignedWorkflows?.length,
                            )
                        }}
                        {{
                            $t(
                                "workflows.steps.workflows",
                                assignedWorkflows?.length,
                            )
                        }}
                    </p>
                </div>
                <div>
                    <Button
                        @click="opened = !opened"
                        size="sm"
                        variant="outline"
                    >
                        <ChevronDown
                            class="transition-all duration-150"
                            :class="[opened ? 'rotate-180 ' : '']"
                            :size="16"
                        />
                    </Button>
                </div>
            </div>

            <div v-if="!opened">
                <div v-if="!isLast" class="flex w-full justify-center">
                    <div class="flex h-4 w-[1px] bg-iron-200"></div>
                </div>
            </div>
            <div v-auto-animate v-if="opened">
                <div
                    class="px-4"
                    v-for="workflow of assignedWorkflows"
                    :key="workflow.id"
                >
                    <div>
                        <div class="flex w-full justify-center">
                            <div class="flex h-4 w-[1px] bg-iron-200"></div>
                        </div>

                        <div
                            class="group flex items-center justify-between gap-1.5 rounded-md border border-iron-200 px-4 py-2"
                        >
                            <div class="flex">
                                <div v-if="workflow.action === 'send_email'">
                                    <Mail
                                        class="text-iron-600"
                                        :size="20"
                                    ></Mail>
                                </div>
                                <div>
                                    <p
                                        class="ml-2 text-sm font-medium text-iron-700"
                                    >
                                        {{
                                            workflow.target === "attendees"
                                                ? locale === "en"
                                                    ? "to attendees"
                                                    : "účastníkům"
                                                : locale === "en"
                                                  ? "to organizer"
                                                  : "organizátorovi"
                                        }}
                                        -
                                        {{ workflow.name }}
                                    </p>
                                    <p
                                        v-if="workflow.data"
                                        class="ml-2 text-sm font-medium text-iron-700"
                                    >
                                        <span
                                            v-if="
                                                JSON.parse(workflow.data)
                                                    ?.timeBefore
                                            "
                                            >-
                                            {{
                                                JSON.parse(workflow.data)
                                                    ?.timeBefore /
                                                60 /
                                                60
                                            }}
                                            hours before</span
                                        >
                                    </p>
                                </div>
                            </div>

                            <div v-auto-animate class="flex gap-3">
                                <!-- <Link
                                    :href="
                                        route('app.workflows.show', {
                                            workflow: workflow.id,
                                        })
                                    "
                                >
                                    <Pencil
                                        class="text-iron-900 opacity-0 transition-all duration-100 ease-out group-hover:block group-hover:opacity-100"
                                        :size="18"
                                    >
                                    </Pencil>
                                </Link> -->
                                <button
                                    :disabled="
                                        isPersonalInTeam === false &&
                                        isOwner === false
                                    "
                                    @click="emit('detachWorkflow', workflow.id)"
                                >
                                    <Trash2
                                        class="opacity-0 transition-all duration-100 ease-out group-hover:block group-hover:opacity-100"
                                        :class="
                                            isPersonalInTeam === false &&
                                            isOwner === false
                                                ? 'cursor-not-allowed text-iron-300'
                                                : 'text-iron-900'
                                        "
                                        :size="18"
                                    >
                                    </Trash2>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex w-full justify-center">
                    <div class="flex h-4 w-[1px] bg-iron-200"></div>
                </div>

                <!-- Show when subscription is not present -->
                <div
                    v-if="!hasSubscription"
                    class="relative flex justify-center"
                >
                    <button
                        @click="proDialog.show({ feature: 'custom_workflow' })"
                    >
                        <Plus
                            class="rounded-md bg-stone-100 text-stone-300 transition-all duration-150 ease-in group-hover:scale-125 group-hover:bg-z-primary-50"
                            :size="24"
                            :stroke-width="2.2"
                        ></Plus>
                        <PaidFeatureIcon
                            class="absolute -top-1.5 left-[51%]"
                        ></PaidFeatureIcon>
                    </button>
                </div>
                <!-- Show when sub is present and user not owner of the team -->
                <div
                    v-else-if="isPersonalInTeam === false && isOwner === false"
                    class="relative flex justify-center"
                >
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger
                                ><button disabled>
                                    <Plus
                                        class="cursor-not-allowed rounded-md bg-stone-100 text-stone-300 transition-all duration-150 ease-in group-hover:scale-125 group-hover:bg-z-primary-50"
                                        :size="24"
                                        :stroke-width="2.2"
                                    ></Plus>
                                </button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>{{ $t("workflows.team_owner_only") }}</p>
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                </div>
                <!-- Show when subscription is present && when in team user is owner of the team -->
                <div v-else class="flex justify-center">
                    <DropdownMenu>
                        <DropdownMenuTrigger as-child>
                            <button class="group">
                                <Plus
                                    class="rounded-md text-z-primary-500 transition-all duration-150 ease-in group-hover:scale-125 group-hover:bg-z-primary-50"
                                    :size="24"
                                    :stroke-width="2.2"
                                ></Plus>
                            </button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent class="w-56">
                            <DropdownMenuGroup>
                                <DropdownMenuSub>
                                    <DropdownMenuSubTrigger>
                                        <Mail class="mr-1 h-4 w-4" />
                                        <span
                                            >Email ({{
                                                filterWorkflows(
                                                    unassignedWorkflows,
                                                    "send_email",
                                                ).length
                                            }})</span
                                        >
                                    </DropdownMenuSubTrigger>
                                    <DropdownMenuPortal>
                                        <DropdownMenuSubContent>
                                            <DropdownMenuItem
                                                v-for="workflows of filterWorkflows(
                                                    unassignedWorkflows,
                                                    'send_email',
                                                )"
                                                @click="
                                                    emit(
                                                        'assignWorkflow',
                                                        workflows.id,
                                                    )
                                                "
                                            >
                                                {{ workflows.name }}
                                            </DropdownMenuItem>
                                            <DropdownMenuSeparator
                                                v-if="
                                                    filterWorkflows(
                                                        unassignedWorkflows,
                                                        'send_email',
                                                    ).length > 0
                                                "
                                            />

                                            <DropdownMenuItem
                                                class="gap-1"
                                                @click="
                                                    openWorkflowCreation({
                                                        action: 'send_email',
                                                    })
                                                "
                                            >
                                                <Plus
                                                    :size="16"
                                                    class="text-iron-600"
                                                />
                                                {{ $t("workflows.create_new") }}
                                            </DropdownMenuItem>
                                        </DropdownMenuSubContent>
                                    </DropdownMenuPortal>
                                </DropdownMenuSub>

                                <DropdownMenuSub
                                    v-if="
                                        integrationTypes.includes('FREELO') &&
                                        ![
                                            'reservation_canceled',
                                            'reservation_will_happen_in',
                                        ].includes(trigger)
                                    "
                                >
                                    <DropdownMenuSubTrigger>
                                        <span
                                            >Freelo ({{
                                                filterWorkflows(
                                                    unassignedWorkflows,
                                                    "add_task_to_freelo",
                                                ).length
                                            }})</span
                                        >
                                    </DropdownMenuSubTrigger>
                                    <DropdownMenuPortal>
                                        <DropdownMenuSubContent>
                                            <DropdownMenuItem
                                                v-for="workflows of filterWorkflows(
                                                    unassignedWorkflows,
                                                    'add_task_to_freelo',
                                                )"
                                                @click="
                                                    emit(
                                                        'assignWorkflow',
                                                        workflows.id,
                                                    )
                                                "
                                            >
                                                >
                                                {{ workflows.name }}
                                            </DropdownMenuItem>

                                            <DropdownMenuSeparator
                                                v-if="
                                                    filterWorkflows(
                                                        unassignedWorkflows,
                                                        'add_task_to_freelo',
                                                    ).length > 0
                                                "
                                            />

                                            <DropdownMenuItem
                                                class="gap-1"
                                                @click="
                                                    openWorkflowCreation({
                                                        action: 'add_task_to_freelo',
                                                    })
                                                "
                                                ><Plus
                                                    :size="16"
                                                    class="text-iron-600"
                                                />

                                                {{ $t("workflows.create_new") }}
                                            </DropdownMenuItem>
                                        </DropdownMenuSubContent>
                                    </DropdownMenuPortal>
                                </DropdownMenuSub>

                                <DropdownMenuSub
                                    v-if="
                                        integrationTypes.includes('ECOMAIL') &&
                                        ![
                                            'reservation_canceled',
                                            'reservation_will_happen_in',
                                        ].includes(trigger)
                                    "
                                >
                                    <DropdownMenuSubTrigger>
                                        <span
                                            >Ecomail ({{
                                                filterWorkflows(
                                                    unassignedWorkflows,
                                                    "add_contact_to_ecomail",
                                                ).length
                                            }})</span
                                        >
                                    </DropdownMenuSubTrigger>
                                    <DropdownMenuPortal>
                                        <DropdownMenuSubContent>
                                            <DropdownMenuItem
                                                v-for="workflows of filterWorkflows(
                                                    unassignedWorkflows,
                                                    'add_contact_to_ecomail',
                                                )"
                                                @click="
                                                    emit(
                                                        'assignWorkflow',
                                                        workflows.id,
                                                    )
                                                "
                                            >
                                                {{ workflows.name }}
                                            </DropdownMenuItem>
                                            <DropdownMenuSeparator
                                                v-if="
                                                    filterWorkflows(
                                                        unassignedWorkflows,
                                                        'add_contact_to_ecomail',
                                                    ).length > 0
                                                "
                                            />

                                            <DropdownMenuItem
                                                class="gap-1"
                                                @click="
                                                    openWorkflowCreation({
                                                        action: 'add_contact_to_ecomail',
                                                    })
                                                "
                                                ><Plus
                                                    :size="16"
                                                    class="text-iron-600"
                                                />

                                                {{ $t("workflows.create_new") }}
                                            </DropdownMenuItem>
                                        </DropdownMenuSubContent>
                                    </DropdownMenuPortal>
                                </DropdownMenuSub>
                                <DropdownMenuSub
                                    v-if="
                                        integrationTypes.includes('CLOSE') &&
                                        ![
                                            'reservation_canceled',
                                            'reservation_will_happen_in',
                                        ].includes(trigger)
                                    "
                                >
                                    <DropdownMenuSubTrigger>
                                        <span
                                            >Close ({{
                                                filterWorkflows(
                                                    unassignedWorkflows,
                                                    "add_lead_to_close",
                                                ).length
                                            }})</span
                                        >
                                    </DropdownMenuSubTrigger>
                                    <DropdownMenuPortal>
                                        <DropdownMenuSubContent>
                                            <DropdownMenuItem
                                                v-for="workflows of filterWorkflows(
                                                    unassignedWorkflows,
                                                    'add_lead_to_close',
                                                )"
                                                @click="
                                                    emit(
                                                        'assignWorkflow',
                                                        workflows.id,
                                                    )
                                                "
                                            >
                                                {{ workflows.name }}
                                            </DropdownMenuItem>

                                            <DropdownMenuSeparator
                                                v-if="
                                                    filterWorkflows(
                                                        unassignedWorkflows,
                                                        'add_lead_to_close',
                                                    ).length > 0
                                                "
                                            />

                                            <DropdownMenuItem
                                                class="gap-1"
                                                @click="
                                                    openWorkflowCreation({
                                                        action: 'add_lead_to_close',
                                                    })
                                                "
                                                ><Plus
                                                    :size="16"
                                                    class="text-iron-600"
                                                />

                                                {{ $t("workflows.create_new") }}
                                            </DropdownMenuItem>
                                        </DropdownMenuSubContent>
                                    </DropdownMenuPortal>
                                </DropdownMenuSub>

                                <DropdownMenuSub
                                    v-if="integrationTypes.includes('SLACK')"
                                >
                                    <DropdownMenuSubTrigger>
                                        <span
                                            >Slack ({{
                                                filterWorkflows(
                                                    unassignedWorkflows,
                                                    "send_to_slack",
                                                ).length
                                            }})</span
                                        >
                                    </DropdownMenuSubTrigger>
                                    <DropdownMenuPortal>
                                        <DropdownMenuSubContent>
                                            <DropdownMenuItem
                                                v-for="workflows of filterWorkflows(
                                                    unassignedWorkflows,
                                                    'send_to_slack',
                                                )"
                                                @click="
                                                    emit(
                                                        'assignWorkflow',
                                                        workflows.id,
                                                    )
                                                "
                                            >
                                                {{ workflows.name }}
                                            </DropdownMenuItem>

                                            <DropdownMenuSeparator
                                                v-if="
                                                    filterWorkflows(
                                                        unassignedWorkflows,
                                                        'send_to_slack',
                                                    ).length > 0
                                                "
                                            />

                                            <DropdownMenuItem
                                                class="gap-1"
                                                @click="
                                                    openWorkflowCreation({
                                                        action: 'send_to_slack',
                                                    })
                                                "
                                                ><Plus
                                                    :size="16"
                                                    class="text-iron-600"
                                                />
                                                {{ $t("workflows.create_new") }}
                                            </DropdownMenuItem>
                                        </DropdownMenuSubContent>
                                    </DropdownMenuPortal>
                                </DropdownMenuSub>
                                <DropdownMenuSub
                                    v-if="
                                        integrationTypes.includes('RAYNET') &&
                                        ![
                                            'reservation_canceled',
                                            'reservation_will_happen_in',
                                        ].includes(trigger)
                                    "
                                >
                                    <DropdownMenuSubTrigger>
                                        <span
                                            >Raynet ({{
                                                filterWorkflows(
                                                    unassignedWorkflows,
                                                    "add_lead_to_raynet",
                                                ).length
                                            }})</span
                                        >
                                    </DropdownMenuSubTrigger>
                                    <DropdownMenuPortal>
                                        <DropdownMenuSubContent>
                                            <DropdownMenuItem
                                                v-for="workflows of filterWorkflows(
                                                    unassignedWorkflows,
                                                    'add_lead_to_raynet',
                                                )"
                                                @click="
                                                    emit(
                                                        'assignWorkflow',
                                                        workflows.id,
                                                    )
                                                "
                                            >
                                                {{ workflows.name }}
                                            </DropdownMenuItem>

                                            <DropdownMenuSeparator
                                                v-if="
                                                    filterWorkflows(
                                                        unassignedWorkflows,
                                                        'add_lead_to_raynet',
                                                    ).length > 0
                                                "
                                            />

                                            <DropdownMenuItem
                                                class="gap-1"
                                                @click="
                                                    openWorkflowCreation({
                                                        action: 'add_lead_to_raynet',
                                                    })
                                                "
                                                ><Plus
                                                    :size="16"
                                                    class="text-iron-600"
                                                />
                                                {{ $t("workflows.create_new") }}
                                            </DropdownMenuItem>
                                        </DropdownMenuSubContent>
                                    </DropdownMenuPortal>
                                </DropdownMenuSub>
                            </DropdownMenuGroup>
                        </DropdownMenuContent>
                    </DropdownMenu>
                </div>
                <div v-if="!isLast" class="flex w-full justify-center">
                    <div class="flex h-4 w-[1px] bg-iron-200"></div>
                </div>
            </div>
        </div>
        <CreatePreselectedWorkflow
            v-if="
                createWorkflowModalData.action &&
                createWorkflowModalData.trigger
            "
            :integrations="integrations"
            :action="createWorkflowModalData.action"
            :trigger="createWorkflowModalData.trigger"
            :event-type="eventType"
            @onClosed="
                () =>
                    (createWorkflowModalData = {
                        action: null,
                        trigger: null,
                    })
            "
        ></CreatePreselectedWorkflow>
    </div>
</template>

<script setup lang="ts">
import type { Workflow } from "../../../Workflows/components/Workflow.vue";
import { ref, computed } from "vue";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuPortal,
    DropdownMenuSub,
    DropdownMenuSubContent,
    DropdownMenuSubTrigger,
    DropdownMenuTrigger,
    DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Mail, Plus, Trash2, ChevronDown, MailPlus } from "lucide-vue-next";
import { Button } from "@/components/ui/button";
import { vAutoAnimate } from "@formkit/auto-animate";
import CreatePreselectedWorkflow from "./CreatePreselectedWorkflow.vue";
import type { EventType } from "../../types/EventType";
import { useHasSubscription } from "@/composables/useHasSubscription";
import PaidFeatureIcon from "../../../Atomic/PaidFeatureIcon.vue";
import useProDialog from "@/ProModal/composables/useProDialog";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import { useI18n } from "vue-i18n";

const { locale } = useI18n();
const props = defineProps<{
    title: string;
    assignedWorkflows: Workflow[];
    unassignedWorkflows: Workflow[];
    isLast?: boolean;
    integrations: any[];
    eventType: EventType;
    isOwner: boolean;
    isPersonalInTeam: boolean;
    trigger:
        | "reservation_made"
        | "reservation_canceled"
        | "reservation_prepared"
        | "reservation_will_happen_in";
}>();

const emit = defineEmits(["assignWorkflow", "detachWorkflow"]);
const opened = ref(true);
type Action =
    | "send_email"
    | "add_task_to_freelo"
    | "add_contact_to_ecomail"
    | "add_lead_to_close"
    | "send_to_slack"
    | "add_lead_to_raynet";

type WorkflowModalData = {
    action: Action | null;
    trigger:
        | "reservation_made"
        | "reservation_canceled"
        | "reservation_prepared"
        | "reservation_will_happen_in"
        | null;
};
const { hasSubscription } = useHasSubscription();
const proDialog = useProDialog();
const createWorkflowModalData = ref<WorkflowModalData>({
    action: null,
    trigger: null,
});

const integrationTypes = computed(() => {
    return props.integrations.map((integration) => integration.type);
});

function filterWorkflows(workflows: Workflow[], action: Action) {
    return workflows.filter((workflow) => workflow.action === action);
}

function openWorkflowCreation({ action }: { action: Action }) {
    createWorkflowModalData.value.action = action;
    createWorkflowModalData.value.trigger = props.trigger;
}
</script>
